import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';
import { FCM } from '@ionic-native/fcm';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AuthProvider } from '../providers/auth/auth';
import { DataProvider } from '../providers/data/data';
import { LabelProvider } from '../providers/label/label';
import { Diagnostic } from '@ionic-native/diagnostic';
import { SignaturePadModule } from 'angular2-signaturepad';
import { Camera} from '@ionic-native/camera';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LogProvider } from '../providers/log/log';
import { MediaProvider } from '../providers/media/media';
import { DealershipProvider } from '../providers/dealership/dealership';
import { OemProvider } from '../providers/oem/oem';
import { CommonProvider } from '../providers/common/common';
import { ConnectivityServiceProvider } from '../providers/connectivity-service/connectivity-service';
import { GoogleMapsProvider } from '../providers/google-maps/google-maps';
import { Network } from '@ionic-native/network';
import { Geolocation } from '@ionic-native/geolocation';
import { AuditScheduleProvider } from '../providers/audit-schedule/audit-schedule';
import { AuditProvider } from '../providers/audit/audit';
import { ActionPlanProvider } from '../providers/action-plan/action-plan';
import { PdfProvider } from '../providers/pdf/pdf';
import { FileTransfer} from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { Base64 } from '@ionic-native/base64';
import { NotificationsProvider } from '../providers/notifications/notifications';
import { HelpProvider } from '../providers/help/help';
import { environment } from '../environments/environment';
import { ImagePicker } from '@ionic-native/image-picker';
import { Device } from '@ionic-native/device';
//import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { SignupPageModule } from '../pages/signup/signup.module';
import { AccountActivationPageModule } from '../pages/account-activation/account-activation.module';
import { SetupModalPageModule } from '../pages/setup-modal/setup-modal.module';
import { SelectActionPageModule } from '../pages/select-action/select-action.module';
import { FaqPageModule } from '../pages/faq/faq.module';
//import { AppRoutingModule } from './app-routing.module';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
   //  AppRoutingModule,
     IonicModule.forRoot(MyApp, {
        tabsHideOnSubPages: true
    }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    IonicStorageModule.forRoot(),
    SignaturePadModule,
    AngularFireModule.initializeApp(environment.firebase, 'australian-council-web'),
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    SignupPageModule,
    AccountActivationPageModule,
    SetupModalPageModule,
    SelectActionPageModule,
    FaqPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    FCM,
    InAppBrowser,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider,
    DataProvider,
    LabelProvider,
    Camera,
    LogProvider,
    MediaProvider,
    DealershipProvider,
    OemProvider,
    CommonProvider,
    Network,
    Geolocation,
    ConnectivityServiceProvider,
    GoogleMapsProvider,
    AuditScheduleProvider,
    AuditProvider,
    ActionPlanProvider,
    PdfProvider,
    File,
    FileTransfer,
    FileOpener,
    PhotoViewer,
    Diagnostic,
    Base64,
    NotificationsProvider,
    HelpProvider,
    ImagePicker,
    Device
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts